import React from 'react';

const Footer: React.FC = () => {
  const [settings, setSettings] = React.useState<import('../../services/settingsService').Settings>({});

  React.useEffect(() => {
    const fetchSettings = async () => {
      try {
        const data = await import('../../services/settingsService').then(m => m.default.getSettings());
        setSettings(data);
      } catch (error) {
        console.error('Error fetching settings for footer:', error);
      }
    };
    fetchSettings();
  }, []);

  return (
    <footer className="bg-canvas-inverted-primary text-fg-inverted-primary py-16 px-6 md:px-12">
      <div className="max-w-container mx-auto">
        <div className="grid md:grid-cols-3 gap-12">
          <div>
            <img
              src="/Logo TOPPED blanco-01.png"
              alt="TOPPED"
              className="h-16 w-auto mb-4"
            />
            <h4 className="text-sm font-bold mb-4 text-fg-highlight-secondary uppercase tracking-widest">
              Sobre Nosotros
            </h4>
            <p className="text-fg-inverted-tertiary leading-relaxed">
              {settings.slogan}
            </p>
          </div>
          <div>
            <h4 className="text-sm font-bold mb-4 text-fg-highlight-secondary uppercase tracking-widest">
              Contacto
            </h4>
            <p className="text-fg-inverted-tertiary">
              {settings.company_email}
            </p>
            {settings.company_phone && (
              <p className="text-fg-inverted-tertiary mt-2">
                {settings.company_phone}
              </p>
            )}
            {settings.company_address && (
              <p className="text-fg-inverted-tertiary mt-2">
                {settings.company_address}
              </p>
            )}
          </div>
          <div>
            <h4 className="text-sm font-bold mb-4 text-fg-highlight-secondary uppercase tracking-widest">
              Síguenos
            </h4>
            <div className="flex flex-col gap-2 text-fg-inverted-tertiary">
              {settings.social_instagram && (
                <a href={settings.social_instagram} target="_blank" rel="noopener noreferrer" className="hover:text-fg-highlight-secondary transition-colors">
                  Instagram
                </a>
              )}
              {settings.social_facebook && (
                <a href={settings.social_facebook} target="_blank" rel="noopener noreferrer" className="hover:text-fg-highlight-secondary transition-colors">
                  Facebook
                </a>
              )}
              {settings.social_twitter && (
                <a href={settings.social_twitter} target="_blank" rel="noopener noreferrer" className="hover:text-fg-highlight-secondary transition-colors">
                  Twitter / X
                </a>
              )}
              {!settings.social_instagram && !settings.social_facebook && !settings.social_twitter && (
                <span>Síguenos en nuestras redes sociales</span>
              )}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
